import styled from 'styled-components';
import { device } from '../../Layout/Grid';


export const FormItem = styled.div`
  margin-bottom: 20px;
  label {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #FFFFFF;
    ${device.xs} {
      font-size: 12px;
      line-height: 24px;
    }
  }
  select {
    margin-top: 8px;
    background: #1F1F1F;
    border: 2px solid #353535;
    box-sizing: border-box;
    width: 100%;
    padding: 10px;
    color: #8F8F8F;
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    ${device.xs} {
      font-size: 12px;
      line-height: 24px;
    }
  }
  option {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    color: #FFFFFF;
    ${device.xs} {
      font-size: 12px;
      line-height: 24px;
    }
  }

`;
